export const viewportWidthIds = {
  XS: 'XS',
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
  XL: 'XL',
  XXL: 'XXL',
}

export const viewportWidthList = [
  {
    id: viewportWidthIds.XS,
    minValue: 0,
    maxValue: 543,
  },
  {
    id: viewportWidthIds.SM,
    minValue: 544,
    maxValue: 767,
  },
  {
    id: viewportWidthIds.MD,
    minValue: 768,
    maxValue: 991,
  },
  {
    id: viewportWidthIds.LG,
    minValue: 992,
    maxValue: 1279,
  },
  {
    id: viewportWidthIds.XL,
    minValue: 1280,
    maxValue: 1599,
  },
  {
    id: viewportWidthIds.XXL,
    minValue: 1600,
    maxValue: Number.MAX_SAFE_INTEGER,
  },
]
